document.querySelectorAll('[data-ahe-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-ahe-tab]');
    const panels = tabs.querySelectorAll('[data-ahe-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.aheTab;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.ahePanel !== group; });
      });
    });
  });
  document.querySelectorAll('.ahe__nav-drop').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      document.querySelectorAll('.ahe__nav-drop').forEach((other) => {
        if (other !== menu) other.removeAttribute('open');
      });
    });
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.ahe__nav-drop')) return;
    document.querySelectorAll('.ahe__nav-drop[open]').forEach((menu) => menu.removeAttribute('open'));
  });